/**
 * Converts first character of string to lowercase
 * @param value Input string to convert
 * @returns String with first character in lowercase
 */
export const firstCharToLower = (value: string | undefined): string => {
    if (!value) return value || '';
    return value.charAt(0).toLowerCase() + value.slice(1);
};

/**
 * Formats a card number string by adding spaces between segments
 * @param number Card number string to format
 * @param oldCard Flag to indicate if using old card format
 * @returns Formatted card number string with spaces
 */
export const formatCardNumber = (number: string, oldCard = false): string =>
    oldCard ? `${number.slice(0, 7)} ${number.slice(7)}` : `${number[0]} ${number.slice(1, 5)} ${number.slice(5)}`;

/**
 * Splits text into two parts based on a pattern
 * @param text Text string to split
 * @param pattern Pattern string to split on
 * @returns Object containing first and second parts of split text
 */
export const splitTextPattern = (text: string, pattern: string): { before: string; after: string } => {
    const parts = text.split(pattern);
    return {
        before: parts[0],
        after: parts[1]
    };
};

/**
 * Returns empty string if value is null/undefined, otherwise returns the value
 * @param value Input string to check
 * @returns Original string or empty string if null/undefined
 */
export const validateStringValue = (value: string | undefined | null): string => {
    return value ?? '';
};
